/* eslint-disable no-nested-ternary */
import translateIndicatorCategory from "components/financials/translateIndicatorCategory";
import { useIntl } from "react-intl";
import type { IIndicatorCategory } from "types/graphqlTypes";

interface IndicatorCategoryNameProps {
  category: IIndicatorCategory;
}
export default function IndicatorCategoryName({ category }: IndicatorCategoryNameProps) {
  const intl = useIntl();
  const languageCode = intl.locale === "pt-BR" ? "pt" : "en";
  return <>{translateIndicatorCategory(category, languageCode)}</>;
}
